import { registerFragment } from '@redwoodjs/web/apollo';

registerFragment(gql`
  fragment BillSalesOrderFragment on SalesOrder {
    id
    slug
    flagged
    status
    currencyCode
    customFields
    exchangeRate
    customerPo
    submittedAt
    deliveryDate
    shipDate
    salesTerms
    billTo {
      displayName
    }
    salesPerson {
      id
      user {
        id
        fullName
      }
    }
    businessEntity {
      id
      name
    }
    lineItems {
      ...LineItemAttributes
      billLineItem {
        id
        billId
        ledgerAccount {
          id
          accountName
          accountType
          accountNumber
        }
      }
    }
    expenses {
      ...ExpenseAttributes
      bills {
        id
        status
        slug
        type
      }
    }
    shipment {
      ...BillShipmentFragment
    }
    documents {
      ...BillDocumentFragment
    }
  }
`);
